import React from "react";
import { connect } from "react-redux";
import { Header, Segment } from "semantic-ui-react";

import { SetCoiButton } from "./";

import { fetchContract } from "../duck/id";

const Instructions = (props) => {
  const { payment } = props;

  const steps = {
    // dealer: {
    //   title: 'Dealer',
    //   instructions: payment ? 'Information about the dealer' : 'Choose your dealer',
    // },
    documents: {
      title: "Documents",
      instructions: "Upload required documents for the contract",
    },
    payment: {
      title: "Payment",
      instructions: payment ? "Payment Information" : "Pay for the contract",
    },
    preview: {
      title: "Preview",
      instructions: "Sign the contract",
    },
    renter: {
      title: "Renter",
      instructions: "Add renter information",
    },
    systems: {
      title: "Systems",
      instructions: payment
        ? "System Information"
        : "Choose systems for this contract",
    },
    term: {
      title: "Term",
      instructions: payment
        ? "Term Information"
        : "Choose a payment plan from Atwood Rentals",
    },
  };

  const stepObj = steps[props.step];

  if (!stepObj) {
    return <div></div>;
  }

  return (
    <div>
      <Segment padded>
        <Header size="huge">
          <Header.Content style={{ width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ flexGrow: "1" }}>
                {stepObj.title}
                <Header.Subheader>{stepObj.instructions}</Header.Subheader>
              </div>
              {props.dealerName && props.contractId && (
                <SetCoiButton
                  coiGood={props.coisGood && props.dealerVerified}
                  contractId={props.contractId}
                  dealerVerified={props.dealerVerified}
                  onSuccess={() =>
                    props.fetchContractData(props.contractId, props.activeStep)
                  }
                />
              )}
            </div>
          </Header.Content>
        </Header>
      </Segment>
      {payment && (
        <Segment color="green">
          <Header
            content="PAID"
            subheader="This contract has been paid for. Editing will be limited"
            icon="circle check"
            color="green"
          />
        </Segment>
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    coisGood: state.coisGood,
    contractId: state.id,
    dealerName: state.dealer ? state.dealer.name : null,
    dealerVerified: state.dealer ? state.dealer.cois_good : false,
    defaultPricebook: state.defaultPricebook,
    payment: state.payment,
    showSave: state.showSave,
    step: state.activeStep,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchContractData: (id, activeStep) =>
    dispatch(fetchContract(id, activeStep)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Instructions);
